"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useComparisonNavigation = _interopRequireDefault(require("../../hooks/comparison/useComparisonNavigation"));
var _services = require("../../services");
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useConfig = _interopRequireDefault(require("../../hooks/useConfig"));
var _useComparison = _interopRequireDefault(require("../../hooks/comparison/useComparison"));
var _BaseComponents = require("../StyledComponents/BaseComponents");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FooterWrapper = _styledComponents.default.div`
  overflow: hidden;
`;
const ComparisonFooter = _ref => {
  var _buttonTheme$appearan;
  let {
    showBackButton
  } = _ref;
  const {
    onBack
  } = (0, _useComparisonNavigation.default)();
  const {
    showPlans,
    showBusinessSolution
  } = (0, _useComparison.default)();
  const withGridView = (0, _useConfig.default)('comparisonSettings.withGridView', false);
  const showGridView = (showPlans || showBusinessSolution) && withGridView;
  const backBtnAttr = {
    id: 'comparison-button-back',
    text: showGridView ? _services.Services.locale.localeString('Comparison.BackButtonText') : _services.Services.locale.localeString('Questionnaire.ButtonBack'),
    width: 'full',
    appearance: 'alt1',
    onClick: onBack
  };
  const showStickyFooter = (0, _useConfig.default)('uiSettings.showStickyFooter', false);
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const buttonTheme = (0, _useLocalTheme.default)('button');
  return /*#__PURE__*/_react.default.createElement(FooterWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: 'center'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: breakpoints.sm ? 11 : 5
  }, showBackButton && /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
    theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan = buttonTheme.appearance) === null || _buttonTheme$appearan === void 0 ? void 0 : _buttonTheme$appearan.alt1,
    mdAndBelow: breakpoints.mdAndBelow
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, backBtnAttr))))), showStickyFooter && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 6
    }
  }));
};
var _default = ComparisonFooter;
exports.default = _default;